module.exports = __webpack_public_path__ + "assets/3f5a64f467c29a7e81801e88fcf950b3.mp3";